export default "__VITE_ASSET__B$YdbDEp__"